import React from 'react';
import { useInView } from '../hooks/useInView';
export function OpeningHook() {
  const {
    ref,
    isVisible
  } = useInView();
  return <section className="py-20 px-4 bg-[#0F0F0F]" data-id="element-150">
      <div className="max-w-3xl mx-auto" data-id="element-151">
        <div ref={ref} className={isVisible ? 'anim-fade-up' : 'anim-hidden'} data-id="element-152">
          <p className="font-serif text-2xl md:text-3xl text-gold-400 leading-snug mb-8" data-id="element-153">
            Hay algo que nadie te dijo cuando empezaste a trabajar.
          </p>
          <p className="text-gray-300 mb-6" data-id="element-154">
            No te lo dijo tu papá. No te lo enseñaron en la escuela. Y tu jefe,
            desde ya, jamás va a explicártelo.
          </p>
          <p className="text-2xl font-bold text-white mb-8 border-l-4 border-gold-500 pl-6 py-2" data-id="element-155">
            El dinero no desaparece por magia. Desaparece por sistema.
          </p>
          <p className="text-gray-300 mb-6" data-id="element-156">
            Y mientras vos no tengas un sistema propio, el dinero va a seguir
            yéndose — al supermercado, a las cuotas, a los gastos que
            "surgieron", a esa compra que parecía pequeña — sin que puedas hacer
            nada al respecto.
          </p>
          <p className="text-gray-300 mb-8" data-id="element-157">
            No es que sos gastador. No es que ganás poco. No es que sos
            irresponsable.
          </p>
          <p className="text-xl md:text-2xl font-semibold text-white mb-8" data-id="element-158">
            Es que nadie te enseñó el único sistema que realmente funciona para
            alguien que cobra un sueldo.
          </p>
          <p className="font-serif text-3xl text-gold-400 italic" data-id="element-159">
            Y hoy eso cambia.
          </p>
        </div>
      </div>
    </section>;
}